import React from "react";
import PropTypes from "prop-types";
import Button from "../Button";
import Stopwatch from "../Stopwatch";

import styles from "./prices.module.scss";

function Price(props) {
  const {basePrice, currentPrice, buttonAction, buttonText, around} = props;
  const hasDiscount = currentPrice < basePrice;
  return (
    <div className={styles.root}>
      {hasDiscount && <div className={styles.basePrice}>{basePrice}</div>}
      <div className={styles.currentPrice}>
        {around && `от `}
        {currentPrice}₽
      </div>
      {hasDiscount ? (
        <div className={styles.sale}>
          <Button size="small" variant="contained" style="danger">
            <Stopwatch from="now" to="next-day" />
          </Button>
          <span className={styles.saleLabel}> – до конца скидки</span>
        </div>
      ) : (
        <Button
          className={styles.watcher}
          size="small"
          variant="outlined"
          style="primary"
          onClick={buttonAction}
        >
          {buttonText}
        </Button>
      )}
    </div>
  );
}

Price.propTypes = {
  basePrice: PropTypes.number,
  currentPrice: PropTypes.number,
  buttonAction: PropTypes.func,
  buttonText: PropTypes.string,
  around: PropTypes.bool
};

export default Price;
